/*###########################################################################
// App
//#########################################################################*/

/* Third party
//------------------*/

import '@js/thirdParty'

/* CSS
//------------------*/

import "@css/app.css"

/* App
//------------------*/

window.app = {
  disableScroll() {
    document.documentElement.style.overflow = 'hidden'
  },

  enableScroll() {
    document.documentElement.style.overflow = ''
  }
}

// Log focus target when navigating with Tab
let lastInteractionWasTab = false

window.addEventListener('keydown', (event) => {
  if (event.key === 'Tab') {
    lastInteractionWasTab = true
  }
})

window.addEventListener('focusin', (event) => {
  if (!lastInteractionWasTab) return

  lastInteractionWasTab = false
  console.log('Tab focus:', event.target)
})

/* Components
//------------------*/

import '@js/components/index'

/* Vendor
//------------------*/

import '@js/vendor/index'

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
*/

// Stores
//
import '@js/stores/_cart'
import '@js/stores/_product'

// Components & Start Alpine
//
import Alpine from 'alpinejs'
import { addToCart } from '@js/components/_addToCart'
import { addToCartPackage } from '@js/components/_addToCartPackage'
import { cardProduct } from '@js/components/_cardProduct'
import { cartLineItem } from '@js/components/_cartLineItem'
import { contactForm } from '@js/components/_contactForm'
import { customSelect } from '@js/components/_customSelect'
import { enquiry } from '@js/components/_enquiry'
import { eventDetailsForm } from '@js/components/_eventDetailsForm'
import { filterCategory } from '@js/components/_filterCategory'
import { signupForm, loginForm } from '@js/components/_signUpForm'
import { header } from '@js/components/_header'
import { flooringEnquiry } from '@js/components/_flooringEnquiry'
import { variantExpand } from '@js/components/_variantExpand'

/* Register components */
Alpine.data('addToCart', addToCart)
Alpine.data('addToCartPackage', addToCartPackage)
Alpine.data('cardProduct', cardProduct)
Alpine.data('cartLineItem', cartLineItem)
Alpine.data('customSelect', customSelect)
Alpine.data('contactForm', contactForm)
Alpine.data('eventDetailsForm', eventDetailsForm)
Alpine.data('enquiry', enquiry)
Alpine.data('filterCategory', filterCategory)
Alpine.data('header', header)
Alpine.data('loginForm', loginForm)
Alpine.data('signupForm', signupForm)
Alpine.data('flooringEnquiry', flooringEnquiry)
Alpine.data('variantExpand', variantExpand)
Alpine.start()

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  })
}
